import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';

export function useWeather(startDate, endDate, accountName) {
  const [weather, setWeather] = useState({ city: '', days: [] });

  useEffect(() => {
    if (!startDate || !endDate) return;
    apiClient.get('/weather', { params: { startDate, endDate, accountName } })
      .then(r => setWeather(r.data))
      .catch(() => {}); // non-critical — fail silently
  }, [startDate, endDate, accountName]);

  return weather;
}
